import React from 'react';
import { motion } from 'framer-motion';
import { useLang } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';

const Section = ({ num, title, children }) => (
  <motion.section
    className="flex flex-col gap-4"
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.4 }}
  >
    <div className="flex items-baseline gap-3">
      <span className="text-headingColor font-black text-sm tabular-nums">{num}.</span>
      <h2 className="text-xl font-black text-gray-900 tracking-tight">{title}</h2>
    </div>
    <div className="pl-6 text-gray-500 text-sm leading-relaxed flex flex-col gap-3">{children}</div>
    <div className="w-full h-px bg-gray-100 mt-2" />
  </motion.section>
);

const renderBlock = (block, i) => {
  if (block.type === 'p') return <p key={i} dangerouslySetInnerHTML={{ __html: block.html }} />;
  if (block.type === 'ul') return (
    <ul key={i} className="list-disc list-inside space-y-1 pl-2">
      {block.items.map((item, j) => <li key={j} dangerouslySetInnerHTML={{ __html: item }} />)}
    </ul>
  );
  return null;
};

const CookiesContainer = () => {
  const { lang } = useLang();
  const t = translations[lang].cookies;

  return (
    <div className="w-full min-h-screen bg-gray-950">

      {/* ── Banner ── */}
      <div className="relative w-full bg-gray-950 pt-10 pb-16 px-6 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,1) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,1) 1px,transparent 1px)', backgroundSize: '50px 50px' }} />
        <div className="absolute right-0 top-0 w-[500px] h-[400px] bg-headingColor/8 rounded-full blur-[100px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-950 to-transparent pointer-events-none" />
        <div className="relative max-w-4xl mx-auto text-center">
          <p className="text-headingColor text-xs font-bold tracking-widest uppercase mb-3">{t.eyebrow}</p>
          <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight mb-4">{t.title}</h1>
          <p className="text-gray-500 text-sm">{t.lastUpdated}</p>
        </div>
      </div>

      {/* ── Document ── */}
      <div className="w-full bg-white py-16 px-6">
        <div className="max-w-3xl mx-auto flex flex-col gap-10">

          <motion.div
            className="bg-headingColor/5 border border-headingColor/15 rounded-2xl p-6 text-sm text-gray-600 leading-relaxed"
            initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          >
            {t.intro}
          </motion.div>

          {t.sections.map(section => (
            <Section key={section.num} num={section.num} title={section.title}>
              {section.blocks.map(renderBlock)}
            </Section>
          ))}

        </div>
      </div>
    </div>
  );
};

export default CookiesContainer;
